import api from '../../api/api';

export default {
  name: 'forgot-password',
  data() {
    return {
      user: {
        userEmail: '',
      },
      submitting: false,
      emailSent: false,
    };
  },
  methods: {
    forgotPassword() {
      this.submitting = true;

      api
        .forgotPassword(this.user.userEmail.trim())
        .then(() => (this.emailSent = true), (this.user.userEmail = ''))
        .catch((err) => err)
        .finally(() => (this.submitting = false));
    },
  },
};
